namespace Portico.Services.Legacy.CardService {
    import Api = Portico.Services.Legacy.CardService.Api;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;
    const apiModule = angular.module('app')
    .service('LegacyCardService.ActivateCardApi', Api.ActivateCardApi)
    .service('LegacyCardService.CreateCardApi', Api.CreateCardApi)
    .service('LegacyCardService.MemberNumberStatusApi', Api.MemberNumberStatusApi)
    .service('LegacyCardService.ReplaceCardApi', Api.ReplaceCardApi)
    .service('LegacyCardService.TerminateCardApi', Api.TerminateCardApi)

    export interface ILegacyCardService {
        ActivateCardApi: Api.ActivateCardApi;
        CreateCardApi: Api.CreateCardApi;
        MemberNumberStatusApi: Api.MemberNumberStatusApi;
        ReplaceCardApi: Api.ReplaceCardApi;
        TerminateCardApi: Api.TerminateCardApi;
    }

    @Service('app', 'LegacyCardService')
    @Inject(
    'LegacyCardService.ActivateCardApi',
        'LegacyCardService.CreateCardApi',
        'LegacyCardService.MemberNumberStatusApi',
        'LegacyCardService.ReplaceCardApi',
        'LegacyCardService.TerminateCardApi',
    )
    export class LegacyCardService implements ILegacyCardService {
        constructor(
            public ActivateCardApi: Api.ActivateCardApi,
            public CreateCardApi: Api.CreateCardApi,
            public MemberNumberStatusApi: Api.MemberNumberStatusApi,
            public ReplaceCardApi: Api.ReplaceCardApi,
            public TerminateCardApi: Api.TerminateCardApi,
        ){}
    }     
}